var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconCouponsBig = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 79.861,
  height: 79.861,
  viewBox: "0 0 79.861 79.861",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_1197",
  "data-name": "Group 1197",
  transform: "translate(-1020 -1987.664)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ticket",
  transform: "translate(1020 1987.664)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_182",
  "data-name": "Path 182",
  d: "M122.785,199.968a1.566,1.566,0,1,0-1.107-.459A1.578,1.578,0,0,0,122.785,199.968Zm0,0",
  transform: "translate(-102.314 -166.139)",
  fill: "#153968"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_183",
  "data-name": "Path 183",
  d: "M260.065,201.123a1.568,1.568,0,1,0,.458,1.107A1.579,1.579,0,0,0,260.065,201.123Zm0,0",
  transform: "translate(-217.25 -169.37)",
  fill: "#153968"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_184",
  "data-name": "Path 184",
  d: "M293.958,168.8a1.566,1.566,0,1,0-1.108-.459A1.578,1.578,0,0,0,293.958,168.8Zm0,0",
  transform: "translate(-246.791 -139.828)",
  fill: "#153968"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_185",
  "data-name": "Path 185",
  d: "M75.182,38.37H70.83l7.661-7.661a4.68,4.68,0,0,0,0-6.618l-6.949-6.949a1.56,1.56,0,0,0-2.206,0,4.679,4.679,0,0,1-6.618-6.618,1.559,1.559,0,0,0,0-2.206L55.771,1.371a4.678,4.678,0,0,0-6.618,0L23.391,27.132A1.56,1.56,0,1,0,25.6,29.338L51.359,3.577a1.559,1.559,0,0,1,2.206,0L59.52,9.532a7.8,7.8,0,0,0,10.81,10.81L76.285,26.3a1.561,1.561,0,0,1,0,2.206L66.418,38.37H59.58L64.7,33.246a1.56,1.56,0,0,0,0-2.206L48.822,15.157a1.56,1.56,0,0,0-2.206,0L23.4,38.37H4.679A4.685,4.685,0,0,0,0,43.05v9.827a1.56,1.56,0,0,0,1.56,1.56,4.679,4.679,0,0,1,0,9.359A1.56,1.56,0,0,0,0,65.355v9.827a4.685,4.685,0,0,0,4.679,4.679h70.5a4.685,4.685,0,0,0,4.679-4.679V65.355a1.56,1.56,0,0,0-1.56-1.56,4.679,4.679,0,1,1,0-9.359,1.56,1.56,0,0,0,1.56-1.56V43.05A4.685,4.685,0,0,0,75.182,38.37Zm-27.463-19.9L61.4,32.143,55.168,38.37H48.992L53.564,33.8a1.56,1.56,0,0,0-2.206-2.206L44.58,38.37H27.815ZM76.742,51.473a7.8,7.8,0,0,0,0,15.285v8.423a1.562,1.562,0,0,1-1.56,1.56H4.679a1.562,1.562,0,0,1-1.56-1.56V66.758a7.8,7.8,0,0,0,0-15.285V43.05a1.561,1.561,0,0,1,1.56-1.56h70.5a1.561,1.561,0,0,1,1.56,1.56Zm0,0",
  transform: "translate(0 0)",
  fill: "#153968"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_186",
  "data-name": "Path 186",
  d: "M199.173,347.669a1.565,1.565,0,1,0-1.107.459A1.578,1.578,0,0,0,199.173,347.669Zm0,0",
  transform: "translate(-165.855 -291.193)",
  fill: "#153968"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_187",
  "data-name": "Path 187",
  d: "M298.173,347.669a1.564,1.564,0,1,0-1.107.459A1.579,1.579,0,0,0,298.173,347.669Zm0,0",
  transform: "translate(-249.415 -291.193)",
  fill: "#153968"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_188",
  "data-name": "Path 188",
  d: "M248.673,347.669a1.565,1.565,0,1,0-1.108.459A1.579,1.579,0,0,0,248.673,347.669Zm0,0",
  transform: "translate(-207.635 -291.193)",
  fill: "#153968"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_189",
  "data-name": "Path 189",
  d: "M148.566,348.128a1.567,1.567,0,1,0-1.107-.459A1.578,1.578,0,0,0,148.566,348.128Zm0,0",
  transform: "translate(-124.075 -291.193)",
  fill: "#153968"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_190",
  "data-name": "Path 190",
  d: "M347.673,347.669a1.565,1.565,0,1,0-1.107.459A1.579,1.579,0,0,0,347.673,347.669Zm0,0",
  transform: "translate(-291.196 -291.193)",
  fill: "#153968"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_191",
  "data-name": "Path 191",
  d: "M148.566,396.128h31.008a1.566,1.566,0,0,0,0-3.132H148.566a1.566,1.566,0,1,0,0,3.132Zm0,0",
  transform: "translate(-124.139 -331.707)",
  fill: "#153968"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_192",
  "data-name": "Path 192",
  d: "M184.887,441a1.567,1.567,0,1,0,1.107.459A1.579,1.579,0,0,0,184.887,441Zm0,0",
  transform: "translate(-154.731 -372.254)",
  fill: "#153968"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_193",
  "data-name": "Path 193",
  d: "M142.863,297H95.556A1.561,1.561,0,0,0,94,298.562v22.551a1.562,1.562,0,0,0,1.556,1.566h6.482a1.566,1.566,0,0,0,0-3.132H97.112V300.128h44.195v19.419H116.044a1.566,1.566,0,0,0,0,3.132h26.819a1.562,1.562,0,0,0,1.556-1.566V298.562A1.561,1.561,0,0,0,142.863,297Zm0,0",
  transform: "translate(-79.279 -250.806)",
  fill: "#153968"
})))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCouponsBig, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_coupons_big.3729c48f.svg";
export { ForwardRef as ReactComponent };